import { createReducer, on } from '@ngrx/store';
import {
  CheckIfDailyReportCanBeCreatedFailure,
  CheckIfDailyReportCanBeCreatedRequest,
  CheckIfDailyReportCanBeCreatedSuccess,
  ClearBidSheet,
  ClearChangeInWorkRequestWithId,
  ClearChangeOrdersRequestWithId,
  ClearDailyReportRequest,
  ClearRFIItemDetailsWithId,
  ClearSitesListRequest,
  ClearState,
  ClearSubmittalsItemDetailsWithId,
  CreateDailyReportDraftFailure,
  CreateDailyReportDraftRequest,
  CreateDailyReportDraftSuccess,
  FetchActivityIdsListFailure,
  FetchActivityIdsListRequest,
  FetchActivityIdsListSuccess,
  FetchAllBidItemsFailure,
  FetchAllBidItemsRequest,
  FetchAllBidItemsSuccess,
  FetchBasisOfPayOptionsFailure,
  FetchBasisOfPayOptionsRequest,
  FetchBasisOfPayOptionsSuccess,
  FetchBidItemListWithChangeOrderFailure,
  FetchBidItemListWithChangeOrderInSideNavFailure,
  FetchBidItemListWithChangeOrderInSideNavRequest,
  FetchBidItemListWithChangeOrderInSideNavSuccess,
  FetchBidItemListWithChangeOrderRequest,
  FetchBidItemListWithChangeOrderSuccess,
  FetchBidItemsListFailure,
  FetchBidItemsListRequest,
  FetchBidItemsListSuccess,
  FetchBidItemsSitesListFailure,
  FetchBidItemsSitesListRequest,
  FetchBidItemsSitesListSuccess,
  FetchBidSheetFailure,
  FetchBidSheetRequest,
  FetchBidSheetSuccess,
  FetchSettingsBidSheetFailure,
  FetchSettingsBidSheetRequest,
  FetchSettingsBidSheetSuccess,
  FetchSettingsBidItemsFailure,
  FetchSettingsBidItemsRequest,
  FetchSettingsBidItemsSuccess,
  FetchSettingsBidItemDetailsFailure,
  FetchSettingsBidItemDetailsRequest,
  FetchSettingsBidItemDetailsSuccess,
  FetchBidItemFieldsFailure,
  FetchBidItemFieldsRequest,
  FetchBidItemFieldsSuccess,
  FetchSettingsProjectMaterialsListFailure,
  FetchSettingsProjectMaterialsListRequest,
  FetchSettingsProjectMaterialsListSuccess,
  FetchChangeInWorkCodeOptionsFailure,
  FetchChangeInWorkCodeOptionsRequest,
  FetchChangeInWorkCodeOptionsSuccess,
  FetchChangeInWorkRequestListFailure,
  FetchChangeInWorkRequestListRequest,
  FetchChangeInWorkRequestListSuccess,
  FetchChangeInWorkRequestWithIdFailure,
  FetchChangeInWorkRequestWithIdRequest,
  FetchChangeInWorkRequestWithIdSuccess,
  FetchChangeOrderFilterFailure,
  FetchChangeOrderFilterInSideNavFailure,
  FetchChangeOrderFilterInSideNavRequest,
  FetchChangeOrderFilterInSideNavSuccess,
  FetchChangeOrderFilterRequest,
  FetchChangeOrderFilterSuccess,
  FetchChangeOrdersRequestListFailure,
  FetchChangeOrdersRequestListRequest,
  FetchChangeOrdersRequestListSuccess,
  FetchChangeOrdersRequestWithIdFailure,
  FetchChangeOrdersRequestWithIdRequest,
  FetchChangeOrdersRequestWithIdSuccess,
  SaveChangeOrdersRequestSuccess,
  FetchAvailableCorsFailure,
  FetchAvailableCorsRequest,
  FetchAvailableCorsSuccess,
  FetchDailyReportFailure,
  FetchDailyReportLineageFailure,
  FetchDailyReportLineageRequest,
  FetchDailyReportLineageSuccess,
  FetchDailyReportRequest,
  FetchDailyReportsByDateFailure,
  FetchDailyReportsByDateRequest,
  FetchDailyReportsByDateSuccess,
  FetchDailyReportSuccess,
  SaveDailyReportSuccess,
  FetchEquipmentFilterFailure,
  FetchEquipmentFilterRequest,
  FetchEquipmentFilterSuccess,
  FetchExternalTestsFailure,
  FetchExternalTestsRequest,
  FetchExternalTestsSuccess,
  FetchIssuesFailure,
  FetchIssuesRequest,
  FetchIssuesSuccess,
  FetchIssueTypesFailure,
  FetchIssueTypesRequest,
  FetchIssueTypesSuccess,
  FetchLabNameListFailure,
  FetchLabNameListRequest,
  FetchLabNameListSuccess,
  FetchLaborFilterFailure,
  FetchLaborFilterRequest,
  FetchLaborFilterSuccess,
  FetchLineageFailure,
  FetchLineageRequest,
  FetchLineageSuccess,
  FetchMaterialTestNameListFailure,
  FetchMaterialTestNameListRequest,
  FetchMaterialTestNameListSuccess,
  FetchProjectMaterialTestListFailure,
  FetchProjectMaterialTestListRequest,
  FetchProjectMaterialTestListSuccess,
  FetchNextActionStateFailure,
  FetchNextActionStateRequest,
  FetchNextActionStateSuccess,
  FetchPayappDetailsFailure,
  FetchPayappDetailsRequest,
  FetchPayappDetailsSuccess,
  FetchPayappItemsFailure,
  FetchPayappItemsRequest,
  FetchPayappItemsSuccess,
  FetchPayappsFailure,
  FetchPayappsRequest,
  FetchPayappsSuccess,
  FetchProjectDetailsFailure,
  FetchProjectDetailsRequest,
  FetchProjectDetailsSuccess,
  FetchProjectDocumentsFailure,
  FetchProjectDocumentsRequest,
  FetchProjectDocumentsSuccess,
  UpdateProjectDocumentsBreadcrumbs,
  FetchProjectAccountsFailure,
  FetchProjectAccountsRequest,
  FetchProjectAccountsSuccess,
  FetchProjectInvitationsFailure,
  FetchProjectInvitationsRequest,
  FetchProjectInvitationsSuccess,
  CreateProjectInvitationRequest,
  CreateProjectInvitationSuccess,
  CreateProjectInvitationFailure,
  CreateLaborLookupFailure,
  CreateLaborLookupRequest,
  CreateLaborLookupSuccess,
  CreateEquipmentLookupFailure,
  CreateEquipmentLookupRequest,
  CreateEquipmentLookupSuccess,
  CreateActivityTypeLookupFailure,
  CreateActivityTypeLookupRequest,
  CreateActivityTypeLookupSuccess,
  DeleteLaborLookupRequest,
  DeleteLaborLookupSuccess,
  DeleteLaborLookupFailure,
  DeleteEquipmentLookupRequest,
  DeleteEquipmentLookupSuccess,
  DeleteEquipmentLookupFailure,
  DeleteActivityTypeLookupRequest,
  DeleteActivityTypeLookupSuccess,
  DeleteActivityTypeLookupFailure,
  FetchProjectSitesForInvitationRequest,
  FetchProjectSitesForInvitationSuccess,
  FetchProjectSitesForInvitationFailure,
  FetchProjectMembersFailure,
  FetchProjectMembersRequest,
  FetchProjectMembersSuccess,
  FetchProjectReportFailure,
  FetchProjectReportRequest,
  FetchProjectReportsListFailure,
  FetchProjectReportsListRequest,
  FetchProjectReportsListSuccess,
  FetchProjectReportSuccess,
  FetchProjectsListFailure,
  FetchProjectsListRequest,
  FetchProjectsListSuccess,
  FetchReportFailure,
  FetchReportRequest,
  FetchReportSuccess,
  FetchRFIItemDetailsWithIdFailure,
  FetchRFIItemDetailsWithIdRequest,
  FetchRFIItemDetailsWithIdSuccess,
  FetchRFINoFailure,
  FetchRFINoRequest,
  FetchRFINoSuccess,
  FetchLaborLookupFailure,
  FetchLaborLookupRequest,
  FetchLaborLookupSuccess,
  FetchEquipmentLookupFailure,
  FetchEquipmentLookupRequest,
  FetchEquipmentLookupSuccess,
  FetchActivityTypeLookupFailure,
  FetchActivityTypeLookupRequest,
  FetchActivityTypeLookupSuccess,
  FetchExternalLabLookupFailure,
  FetchExternalLabLookupRequest,
  FetchExternalLabLookupSuccess,
  FetchMaterialTestLabListFailure,
  FetchMaterialTestLabListRequest,
  FetchMaterialTestLabListSuccess,
  CreateExternalLabFailure,
  CreateExternalLabRequest,
  CreateExternalLabSuccess,
  UpdateExternalLabFailure,
  UpdateExternalLabRequest,
  UpdateExternalLabSuccess,
  DeleteExternalLabLookupRequest,
  DeleteExternalLabLookupSuccess,
  DeleteExternalLabLookupFailure,
  FetchRFIsListFailure,
  FetchRFIsListRequest,
  FetchRFIsListSuccess,
  FetchProjectMembersListFailure,
  FetchProjectMembersListRequest,
  FetchProjectMembersListSuccess,
  FetchContractorsListFailure,
  FetchContractorsListRequest,
  FetchContractorsListSuccess,
  FetchDeliveryTrackingFieldsFailure,
  FetchDeliveryTrackingFieldsRequest,
  FetchDeliveryTrackingFieldsSuccess,
  CreateDeliveryTrackingFieldFailure,
  CreateDeliveryTrackingFieldRequest,
  CreateDeliveryTrackingFieldSuccess,
  UpdateDeliveryTrackingFieldFailure,
  UpdateDeliveryTrackingFieldRequest,
  UpdateDeliveryTrackingFieldSuccess,
  DeleteDeliveryTrackingFieldFailure,
  DeleteDeliveryTrackingFieldRequest,
  DeleteDeliveryTrackingFieldSuccess,
  FetchSitesListRequest,
  FetchSitesListSuccess,
  FetchSitesListFailure,
  DeleteSiteRequest,
  CreateContractorFailure,
  CreateContractorRequest,
  CreateContractorSuccess,
  FetchExistingMembersListFailure,
  FetchExistingMembersListRequest,
  FetchExistingMembersListSuccess,
  FetchProjectRolesListFailure,
  FetchProjectRolesListRequest,
  FetchProjectRolesListSuccess,
  FetchSiteDetailsFailure,
  FetchSiteDetailsRequest,
  FetchSiteDetailsSuccess,
  FetchSiteWiseDailyReportSummaryFailure,
  FetchSiteWiseDailyReportSummaryRequest,
  FetchSiteWiseDailyReportSummarySuccess,
  FetchSubContractorFilterFailure,
  FetchSubContractorFilterRequest,
  FetchSubContractorFilterSuccess,
  DeleteSubmittalsItemSuccess,
  FetchSubmittalsItemDetailsWithIdFailure,
  FetchSubmittalsItemDetailsWithIdRequest,
  FetchSubmittalsItemDetailsWithIdSuccess,
  FetchSubmittalsItemsListFailure,
  FetchSubmittalsItemsListRequest,
  FetchSubmittalsItemsListSuccess,
  FetchSubmittalsRegistryListFailure,
  FetchSubmittalsRegistryListRequest,
  FetchSubmittalsRegistryListSuccess,
  FetchUsersListFailure,
  FetchUsersListRequest,
  FetchUsersListSuccess,
  SetCurrentLocation,
  SetQPForMap,
  UpdatePayappStatusFailure,
  UpdatePayappStatusRequest,
  UpdatePayappStatusSuccess,
  FetchBillingSettingsRequest,
  FetchBillingSettingsSuccess,
  FetchBillingSettingsFailure,
  UpdateBillingSettingsRequest,
  UpdateBillingSettingsSuccess,
  UpdateBillingSettingsFailure,
  FetchPayAppSummaryRequest,
  FetchPayAppSummarySuccess,
  FetchPayAppSummaryFailure,
  ClearBillingSettings,
  FetchProjectCalendarRequest,
  FetchProjectCalendarSuccess,
  FetchProjectCalendarFailure,
  UpdateProjectCalendarRequest,
  UpdateProjectCalendarSuccess,
  UpdateProjectCalendarFailure,
  InitializeProjectCalendarRequest,
  InitializeProjectCalendarSuccess,
  InitializeProjectCalendarFailure,
  FetchPayAppTemplatesRequest,
  FetchPayAppTemplatesSuccess,
  FetchPayAppTemplatesFailure,
  CreatePayAppTemplateRequest,
  CreatePayAppTemplateSuccess,
  CreatePayAppTemplateFailure,
  UpdatePayAppTemplateRequest,
  UpdatePayAppTemplateSuccess,
  UpdatePayAppTemplateFailure,
  DeletePayAppTemplateRequest,
  DeletePayAppTemplateSuccess,
  DeletePayAppTemplateFailure,
  PreviewPayAppTemplateRequest,
  PreviewPayAppTemplateSuccess,
  PreviewPayAppTemplateFailure,
  ClearPayAppTemplates,
  CheckEmailExistsRequest,
  CheckEmailExistsSuccess,
  CheckEmailExistsFailure,
  CheckPhoneExistsRequest,
  CheckPhoneExistsSuccess,
  CheckPhoneExistsFailure,
  ClearEmailExistsCheck,
  ClearPhoneExistsCheck,
  ScanBatchTicketRequest,
  ScanBatchTicketSuccess,
  ScanBatchTicketFailure,
  ClearBatchTicketData,
  FetchWarrantiesSuccess,
  FetchWarrantyClaimsSuccess,
  FetchWarrantyClaimDetailSuccess,
  UpdateProjectSuccess,
} from './projects.actions';

// State for this feature
export interface ProjectsState {
  activityIdsListInfo: {
    list: any;
    totalRecords: number;
  };
  allBidItems: any[];
  allBidItemsFilter: any[];
  basisOfPayOptions: any;
  bidItemsListInfo: {
    list: any;
    totalRecords: number;
  };
  settingsBidItemsListInfo: {
    list: any[];
    totalRecords: number;
  };
  bidItemFieldsListInfo: {
    list: any[];
  };
  bidItemsListInfoForSideNav: {
    list: any;
    totalRecords: number;
  };
  bidItemsSiteListInfo: {
    list: any;
    bidItemInfo?: any;
  };
  bidSheet: any;
  settingsBidSheet: any;
  /** Bid item details by id (for settings side nav). */
  settingsBidItemDetailsById: { [bidItemId: string]: any };
  /** Loading flag per bid item id for settings side nav. */
  settingsBidItemDetailsLoadingById: { [bidItemId: string]: boolean };
  /** Project materials list per project id (for settings bid item materials tab). */
  settingsProjectMaterialsListById: { [projectId: string]: any[] };
  changeInWorkCodeOptions: any;
  changeInWorkRequest: any;
  changeInWorkRequestListInfo: {
    list: any;
    totalRecords: number;
    loaded?: boolean;
  };
  changeOrderFilter: {
    list: any;
  };
  changeOrderFilterInContextWithBidItems: {
    list: any;
  };
  changeOrderFilterInSideNav: {
    list: any;
  };
  changeOrdersRequest: any;
  changeOrdersRequestListInfo: {
    list: any;
    totalRecords: number;
  };
  consolidatedProjectData: {
    consolidatedActivityList: any;
    consolidatedBidItemsList: any;
    consolidatedIssues: any;
    consolidatedWeathersList: any;
  };
  currentLocation: any;
  dailyReport: any;
  draftDailyReport: any;
  dailyReportLineage: any;
  dailyReportsByDate: any[];
  emailExistsCheck: {
    email: string;
    exists: boolean;
    account: any;
  } | null;
  phoneExistsCheck: {
    phone: string;
    exists: boolean;
    account: any;
  } | null;
  existingReportId: string;
  issueTypesFilter: any[];
  issueTypesLabelMap: any;
  laborFilter: any[];
  payappItems: {};
  payapps: any[];
  payAppSummaries: {};
  billingSettings: any;
  projectCalendar: any;
  projectCalendarLoading: boolean;
  payAppTemplates: any[];
  payAppTemplatesLoading: boolean;
  selectedPayAppTemplate: any;
  templatePreviewUrl: string | null;
  projectDetails: any;
  projectDocuments: any;
  projectDocumentsBreadcrumbs: Array<{ id: string; name: string }>;
  projectDocumentsCurrentRootId: string | null;
  projectMembersFilterList: any[];
  projectAccountsInfo: {
    list: any[];
    totalRecords: number;
  };
  projectInvitationsInfo: {
    list: any[];
    totalRecords: number;
  };
  projectSitesForInvitation: any[];
  createInvitationLoading: boolean;
  projectReport: any;
  projectReportsList: any[];
  projectsFilterList: any[];
  projectsList: any;
  qpForMap: any;
  reportInfo: any;
  siteDetails: any;
  siteWiseDailyReportsSummary: any[];
  subContractorFilter: any[];
  submittalsItemsListInfo: {
    list: any;
    totalRecords: number;
  };
  rfisListInfo: {
    list: any;
    totalRecords: number;
  };
  projectMembersListInfo: {
    list: any;
    totalRecords: number;
  };
  contractorsListInfo: {
    list: any;
    totalRecords: number;
  };
  deliveryTrackingFieldsListInfo: {
    list: any[];
    totalRecords: number;
  };
  sitesListInfo: {
    list: any;
    totalRecords: number;
  };
  laborLookupData: {
    list: any[];
    totalRecords: number;
  };
  equipmentLookupData: {
    list: any[];
    totalRecords: number;
  };
  activityTypeLookupData: {
    list: any[];
    totalRecords: number;
  };
  externalLabLookupData: {
    list: any[];
    totalRecords: number;
  };
  externalLabListInfo: {
    list: any[];
    totalRecords: number;
  };
  submittalsRegistryListInfo: {
    list: any;
    totalRecords: number;
  };
  usersListInfo: {
    list: any;
  };
  projectRolesListInfo: {
    list: any;
  };
  existingMembersListInfo: {
    list: any;
  };
  equipmentFilter: any[];
  lineageList: any[];
  submittalsItemDetails: any;
  rfiItemDetails: any;
  rfiNo: any;
  materialTestNameList: any;
  labNameList: any;
  projectMaterialTestListInfo: {
    list: any[];
    totalRecords: number;
  };
  availableCors: {
    list: any[];
  };
  batchTicketData: any;
  batchTicketLoading: boolean;
  warrantiesInfo: {
    list: any[];
    totalRecords: number;
  };
  warrantyClaimsInfo: {
    list: any[];
    totalRecords: number;
  };
  warrantyClaimDetail: any;
}

const initialState: ProjectsState = {
  activityIdsListInfo: {
    list: [],
    totalRecords: 0,
  },
  allBidItems: [],
  allBidItemsFilter: [],
  basisOfPayOptions: [],
  bidItemsListInfo: {
    list: [],
    totalRecords: 0,
  },
  settingsBidItemsListInfo: {
    list: [],
    totalRecords: 0,
  },
  bidItemFieldsListInfo: {
    list: [],
  },
  bidItemsListInfoForSideNav: {
    list: [],
    totalRecords: 0,
  },
  bidItemsSiteListInfo: {
    list: [],
    bidItemInfo: {},
  },
  bidSheet: {},
  settingsBidSheet: {},
  settingsBidItemDetailsById: {},
  settingsBidItemDetailsLoadingById: {},
  settingsProjectMaterialsListById: {},
  changeInWorkCodeOptions: [],
  changeInWorkRequest: {},
  changeInWorkRequestListInfo: {
    list: [],
    totalRecords: 0,
  },
  changeOrderFilter: {
    list: [],
  },
  changeOrderFilterInContextWithBidItems: {
    list: [],
  },
  changeOrderFilterInSideNav: {
    list: [],
  },
  changeOrdersRequest: {},
  changeOrdersRequestListInfo: {
    list: [],
    totalRecords: 0,
  },
  rfisListInfo: {
    list: [],
    totalRecords: 0,
  },
  projectMembersListInfo: {
    list: [],
    totalRecords: 0,
  },
  contractorsListInfo: {
    list: [],
    totalRecords: 0,
  },
  deliveryTrackingFieldsListInfo: {
    list: [],
    totalRecords: 0,
  },
  sitesListInfo: {
    list: [],
    totalRecords: 0,
  },
  laborLookupData: {
    list: [],
    totalRecords: 0,
  },
  equipmentLookupData: {
    list: [],
    totalRecords: 0,
  },
  activityTypeLookupData: {
    list: [],
    totalRecords: 0,
  },
  externalLabLookupData: {
    list: [],
    totalRecords: 0,
  },
  externalLabListInfo: {
    list: [],
    totalRecords: 0,
  },
  consolidatedProjectData: {
    consolidatedActivityList: [],
    consolidatedBidItemsList: [],
    consolidatedIssues: [],
    consolidatedWeathersList: [],
  },
  currentLocation: {
    latitude: null,
    longitude: null,
  },
  dailyReport: {},
  draftDailyReport: {},
  dailyReportLineage: null,
  dailyReportsByDate: [],
  emailExistsCheck: null,
  phoneExistsCheck: null,
  existingReportId: '',
  equipmentFilter: [],
  issueTypesFilter: [],
  issueTypesLabelMap: {},
  laborFilter: [],
  payappItems: {},
  payapps: [],
  payAppSummaries: {},
  billingSettings: null,
  projectCalendar: null,
  projectCalendarLoading: false,
  payAppTemplates: [],
  payAppTemplatesLoading: false,
  selectedPayAppTemplate: null,
  templatePreviewUrl: null,
  projectDetails: {},
  projectDocuments: null,
  projectDocumentsBreadcrumbs: [],
  projectDocumentsCurrentRootId: null,
  projectMembersFilterList: [],
  projectAccountsInfo: {
    list: [],
    totalRecords: 0,
  },
  projectInvitationsInfo: {
    list: [],
    totalRecords: 0,
  },
  projectSitesForInvitation: [],
  createInvitationLoading: false,
  projectReport: {},
  projectReportsList: [],
  projectsFilterList: [],
  projectsList: [],
  materialTestNameList: [],
  labNameList: [],
  projectMaterialTestListInfo: {
    list: [],
    totalRecords: 0,
  },
  qpForMap: {},
  reportInfo: {},
  siteDetails: {},
  siteWiseDailyReportsSummary: [],
  subContractorFilter: [],
  submittalsItemsListInfo: {
    list: [],
    totalRecords: 0,
  },
  submittalsRegistryListInfo: {
    list: [],
    totalRecords: 0,
  },
  lineageList: [],
  usersListInfo: {
    list: [],
  },
  projectRolesListInfo: {
    list: [],
  },
  existingMembersListInfo: {
    list: [],
  },
  submittalsItemDetails: {},
  rfiItemDetails: {},
  rfiNo: null,
  availableCors: { list: [] },
  batchTicketData: null,
  batchTicketLoading: false,
  warrantiesInfo: {
    list: [],
    totalRecords: 0,
  },
  warrantyClaimsInfo: {
    list: [],
    totalRecords: 0,
  },
  warrantyClaimDetail: null,
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, () => ({
    ...initialState,
  })),

  // CLEAR DAILY REPORT
  on(SetCurrentLocation, (state, props) => ({
    ...state,
    currentLocation: props.location,
  })),

  // CLEAR DAILY REPORT
  on(ClearDailyReportRequest, state => ({
    ...state,
    dailyReport: initialState.dailyReport,
  })),

  // SET QP FOR MAP
  on(SetQPForMap, (state, props) => ({
    ...state,
    qpForMap: props.qpForMap,
  })),

  // FETCH PROJECTS LIST
  on(FetchProjectsListRequest, state => ({
    ...state,
    projectsList: initialState.projectsList,
  })),
  on(FetchProjectsListSuccess, (state, props) => ({
    ...state,
    ...props.payload,
  })),
  on(FetchProjectsListFailure, state => ({
    ...state,
    projectsList: initialState.projectsList,
  })),

  // FETCH PROJECT DETAILS
  on(FetchProjectDetailsRequest, state => ({
    ...state,
    projectDetails: initialState.projectDetails,
  })),
  on(FetchProjectDetailsSuccess, (state, props) => ({
    ...state,
    projectDetails: props.projectDetails,
  })),
  on(FetchProjectDetailsFailure, state => ({
    ...state,
    projectDetails: initialState.projectDetails,
  })),
  on(UpdateProjectSuccess, (state, props) => ({
    ...state,
    projectDetails: {
      ...state.projectDetails,
      ...props.data,
    },
  })),

  // FETCH PROJECT DOCUMENTS
  on(FetchProjectDocumentsRequest, state => ({
    ...state,
    projectDocuments: initialState.projectDocuments,
    // Preserve breadcrumbs and currentRootId when refreshing documents
    // This allows the folder to remain open after adding files/folders
  })),
  on(FetchProjectDocumentsSuccess, (state, props) => ({
    ...state,
    projectDocuments: props.documents,
  })),
  on(FetchProjectDocumentsFailure, state => ({
    ...state,
    projectDocuments: initialState.projectDocuments,
  })),

  // UPDATE PROJECT DOCUMENTS BREADCRUMBS
  on(UpdateProjectDocumentsBreadcrumbs, (state, props) => ({
    ...state,
    projectDocumentsBreadcrumbs: props.breadcrumbs,
    projectDocumentsCurrentRootId: props.currentRootId,
  })),

  // FETCH SITE WISE DAILY REPORTS SUMMARY
  on(FetchSiteWiseDailyReportSummaryRequest, state => ({
    ...state,
    siteWiseDailyReportsSummary: initialState.siteWiseDailyReportsSummary,
  })),
  on(FetchSiteWiseDailyReportSummarySuccess, (state, props) => ({
    ...state,
    siteWiseDailyReportsSummary: props.siteWiseDailyReportsSummary,
  })),
  on(FetchSiteWiseDailyReportSummaryFailure, state => ({
    ...state,
    siteWiseDailyReportsSummary: initialState.siteWiseDailyReportsSummary,
  })),

  // FETCH PROJECT MEMBERS
  on(FetchProjectMembersRequest, state => ({
    ...state,
    projectMembersFilterList: initialState.projectMembersFilterList,
  })),
  on(FetchProjectMembersSuccess, (state, props) => ({
    ...state,
    projectMembersFilterList: props.projectMembersFilterList,
  })),
  on(FetchProjectMembersFailure, state => ({
    ...state,
    projectMembersFilterList: initialState.projectMembersFilterList,
  })),

  // FETCH PROJECT ACCOUNTS
  on(FetchProjectAccountsRequest, state => ({
    ...state,
    projectAccountsInfo: initialState.projectAccountsInfo,
  })),
  on(FetchProjectAccountsSuccess, (state, props) => ({
    ...state,
    projectAccountsInfo: {
      list: props.projectAccountsInfo.list,
      totalRecords: props.projectAccountsInfo.totalRecords,
    },
  })),
  on(FetchProjectAccountsFailure, state => ({
    ...state,
    projectAccountsInfo: initialState.projectAccountsInfo,
  })),

  // FETCH PROJECT INVITATIONS
  on(FetchProjectInvitationsRequest, state => ({
    ...state,
    projectInvitationsInfo: initialState.projectInvitationsInfo,
  })),
  on(FetchProjectInvitationsSuccess, (state, props) => ({
    ...state,
    projectInvitationsInfo: {
      list: props.projectInvitationsInfo.list,
      totalRecords: props.projectInvitationsInfo.totalRecords,
    },
  })),
  on(FetchProjectInvitationsFailure, state => ({
    ...state,
    projectInvitationsInfo: initialState.projectInvitationsInfo,
  })),

  // CREATE PROJECT INVITATION
  on(CreateProjectInvitationRequest, state => ({
    ...state,
    createInvitationLoading: true,
  })),
  on(CreateProjectInvitationSuccess, state => ({
    ...state,
    createInvitationLoading: false,
  })),
  on(CreateProjectInvitationFailure, state => ({
    ...state,
    createInvitationLoading: false,
  })),

  // FETCH PROJECT SITES FOR INVITATION
  on(FetchProjectSitesForInvitationRequest, state => ({
    ...state,
    projectSitesForInvitation: [],
  })),
  on(FetchProjectSitesForInvitationSuccess, (state, props) => ({
    ...state,
    projectSitesForInvitation: props.projectSitesForInvitation,
  })),
  on(FetchProjectSitesForInvitationFailure, state => ({
    ...state,
    projectSitesForInvitation: [],
  })),

  // CAN DAILY REPORT BE CREATED
  on(CheckIfDailyReportCanBeCreatedRequest, state => ({
    ...state,
    existingReportId: null,
  })),
  on(CheckIfDailyReportCanBeCreatedSuccess, (state, props) => ({
    ...state,
    existingReportId: props.existingReportId,
  })),
  on(CheckIfDailyReportCanBeCreatedFailure, state => state),

  // FETCH PROJECTS REPORTS LIST
  on(FetchProjectReportsListRequest, state => ({
    ...state,
    projectReportsList: initialState.projectReportsList,
  })),
  on(FetchProjectReportsListSuccess, (state, props) => ({
    ...state,
    projectReportsList: props.projectReportsList,
  })),
  on(FetchProjectReportsListFailure, state => state),

  // FETCH PROJECTS REPORT
  on(FetchProjectReportRequest, state => ({
    ...state,
    projectReport: initialState.projectReport,
    consolidatedProjectData: {
      ...initialState.consolidatedProjectData,
    },
  })),
  on(FetchProjectReportSuccess, (state, props) => ({
    ...state,
    projectReport: props.projectReport,
    consolidatedProjectData: {
      ...state.consolidatedProjectData,
      consolidatedBidItemsList: props.consolidatedBidItemsList,
      consolidatedWeathersList: props.consolidatedWeathersList,
      consolidatedActivityList: props.consolidatedActivityList,
    },
  })),
  on(FetchProjectReportFailure, state => state),

  // FETCH PAY APP ITEMS
  on(FetchPayappItemsRequest, state => ({
    ...state,
    payappItems: initialState.payappItems,
  })),
  on(FetchPayappItemsSuccess, (state, props) => {
    const newState = {
      ...state,
      payappItems: {
        ...state.payappItems,
        unpaid: props.payappItems,
      },
    };
    return newState;
  }),
  on(FetchPayappItemsFailure, state => state),

  // FETCH PAY APPS
  on(FetchPayappsRequest, state => ({
    ...state,
    payapps: initialState.payapps,
  })),
  on(FetchPayappsSuccess, (state, props) => ({
    ...state,
    payapps: props.payapps,
  })),
  on(FetchPayappsFailure, state => state),

  // FETCH PAY APP DETAILS
  on(FetchPayappDetailsRequest, state => state),
  on(FetchPayappDetailsSuccess, (state, props) => {
    // Update payapps array with full details if payappDetails is provided
    const updatedPayapps = props.payappDetails
      ? state.payapps.map(p => p.id === props.payappId ? { ...p, ...props.payappDetails } : p)
      : state.payapps;

    const newState = {
      ...state,
      payapps: updatedPayapps,
      payappItems: {
        ...state.payappItems,
        [props.payappId]: Array.isArray(props.payappItems) ? props.payappItems : [], // Ensure it's stored as an array
      },
    };
    return newState;
  }),
  on(FetchPayappDetailsFailure, state => state),

  // UPDATE PAY APP STATUS REQUEST
  on(UpdatePayappStatusRequest, state => state),
  on(UpdatePayappStatusSuccess, (state, { data }) => {
    // Find the "unpaid" pay app list and update the item with the new status and comments
    const updatedPayappItems = { ...state.payappItems };
    if (updatedPayappItems['unpaid']) {
      updatedPayappItems['unpaid'] = updatedPayappItems['unpaid'].map(item =>
        item.report_bid_item_id === data.report_bid_item_id
          ? { ...item, pay_app_status: data.status, pay_app_comments: data.comments, pay_app_quantity: data.quantity ?? null }
          : item
      );
    }
    return {
      ...state,
      payappItems: updatedPayappItems,
    };
  }),
  on(UpdatePayappStatusFailure, state => state),

  // FETCH SITE DETAILS
  on(FetchSiteDetailsRequest, state => ({
    ...state,
    siteDetails: initialState.siteDetails,
  })),
  on(FetchSiteDetailsSuccess, (state, props) => ({
    ...state,
    siteDetails: props.siteDetails,
  })),
  on(FetchSiteDetailsFailure, state => state),

  // FETCH DAILY REPORTS BY DATE
  on(FetchDailyReportsByDateRequest, state => ({
    ...state,
    dailyReportsByDate: initialState.dailyReportsByDate,
  })),
  on(FetchDailyReportsByDateSuccess, (state, props) => ({
    ...state,
    dailyReportsByDate: props.dailyReportsByDate,
  })),
  on(FetchDailyReportsByDateFailure, state => state),

  // FETCH DAILY REPORT
  on(FetchDailyReportRequest, state => ({
    ...state,
    dailyReport: initialState.dailyReport,
  })),
  on(FetchDailyReportSuccess, (state, props) => ({
    ...state,
    dailyReport: props.dailyReport,
  })),
  on(FetchDailyReportFailure, state => state),

  // SAVE DAILY REPORT: keep the loaded report's updated_at current, so the next save from
  // this tab sends the version it just wrote as base_updated_at (and doesn't conflict with
  // itself) even before the post-save re-fetch lands.
  on(SaveDailyReportSuccess, (state, props) => {
    const current = state.dailyReport;
    if (!props?.updatedAt || !current?.id || (props?.reportId && props.reportId !== current.id)) {
      return state;
    }
    return { ...state, dailyReport: { ...current, updated_at: props.updatedAt } };
  }),

  // FETCH BID ITEMS
  on(FetchAllBidItemsRequest, state => ({
    ...state,
    allBidItems: initialState.allBidItems,
    allBidItemsFilter: initialState.allBidItemsFilter,
  })),
  on(FetchAllBidItemsSuccess, (state, props) => ({
    ...state,
    allBidItems: props.allBidItems,
    allBidItemsFilter: props.allBidItemsFilter,
  })),
  on(FetchAllBidItemsFailure, state => state),

  // CLEAR BID SHEET
  on(ClearBidSheet, state => ({
    ...state,
    bidSheet: initialState.bidSheet,
    bidItemsListInfo: initialState.bidItemsListInfo,
  })),

  // FETCH BID SHEET
  on(FetchBidSheetRequest, state => ({
    ...state,
  })),
  on(FetchBidSheetSuccess, (state, props) => ({
    ...state,
    bidSheet: props.bidSheet,
  })),
  on(FetchBidSheetFailure, state => ({
    ...state,
    bidSheet: initialState.bidSheet,
  })),

  // FETCH SETTINGS BID SHEET
  on(FetchSettingsBidSheetRequest, state => ({
    ...state,
    settingsBidSheet: initialState.settingsBidSheet,
  })),
  on(FetchSettingsBidSheetSuccess, (state, props) => ({
    ...state,
    settingsBidSheet: props.settingsBidSheet,
  })),
  on(FetchSettingsBidSheetFailure, state => ({
    ...state,
    settingsBidSheet: initialState.settingsBidSheet,
  })),

  // FETCH SETTINGS BID ITEM DETAILS
  on(FetchSettingsBidItemDetailsRequest, (state, props) => ({
    ...state,
    settingsBidItemDetailsById: { ...state.settingsBidItemDetailsById },
    settingsBidItemDetailsLoadingById: {
      ...state.settingsBidItemDetailsLoadingById,
      [props.bidItemId]: true,
    },
  })),
  on(FetchSettingsBidItemDetailsSuccess, (state, props) => ({
    ...state,
    settingsBidItemDetailsById: {
      ...state.settingsBidItemDetailsById,
      [props.bidItemId]: props.bidItem,
    },
    settingsBidItemDetailsLoadingById: (() => {
      const next = { ...state.settingsBidItemDetailsLoadingById };
      delete next[props.bidItemId];
      return next;
    })(),
  })),
  on(FetchSettingsBidItemDetailsFailure, (state, props) => ({
    ...state,
    settingsBidItemDetailsById: (() => {
      const next = { ...state.settingsBidItemDetailsById };
      delete next[props.bidItemId];
      return next;
    })(),
    settingsBidItemDetailsLoadingById: (() => {
      const next = { ...state.settingsBidItemDetailsLoadingById };
      delete next[props.bidItemId];
      return next;
    })(),
  })),

  // FETCH BID ITEMS LIST
  on(FetchBidItemsListRequest, state => ({
    ...state,
    ...initialState.bidItemsListInfo,
  })),
  on(FetchBidItemsListSuccess, (state, props) => ({
    ...state,
    bidItemsListInfo: {
      list: props.bidItemsListInfo.list,
      totalRecords: props.bidItemsListInfo.totalRecords,
    },
  })),
  on(FetchBidItemsListFailure, state => ({
    ...state,
    ...initialState.bidItemsListInfo,
  })),

  // FETCH SETTINGS BID ITEMS
  on(FetchSettingsBidItemsRequest, state => ({
    ...state,
    settingsBidItemsListInfo: initialState.settingsBidItemsListInfo,
  })),
  on(FetchSettingsBidItemsSuccess, (state, props) => ({
    ...state,
    settingsBidItemsListInfo: {
      list: props.settingsBidItemsListInfo.list,
      totalRecords: props.settingsBidItemsListInfo.totalRecords,
    },
  })),
  on(FetchSettingsBidItemsFailure, state => ({
    ...state,
    settingsBidItemsListInfo: initialState.settingsBidItemsListInfo,
  })),

  on(FetchBidItemFieldsRequest, state => ({
    ...state,
    bidItemFieldsListInfo: initialState.bidItemFieldsListInfo,
  })),
  on(FetchBidItemFieldsSuccess, (state, props) => ({
    ...state,
    bidItemFieldsListInfo: {
      list: props.list,
    },
  })),
  on(FetchBidItemFieldsFailure, state => ({
    ...state,
    bidItemFieldsListInfo: initialState.bidItemFieldsListInfo,
  })),

  on(FetchSettingsProjectMaterialsListRequest, (state, props) => ({
    ...state,
    settingsProjectMaterialsListById: { ...state.settingsProjectMaterialsListById },
  })),
  on(FetchSettingsProjectMaterialsListSuccess, (state, props) => ({
    ...state,
    settingsProjectMaterialsListById: {
      ...state.settingsProjectMaterialsListById,
      [props.projectId]: props.list ?? [],
    },
  })),
  on(FetchSettingsProjectMaterialsListFailure, (state, props) => ({
    ...state,
    settingsProjectMaterialsListById: (() => {
      const next = { ...state.settingsProjectMaterialsListById };
      delete next[props.projectId];
      return next;
    })(),
  })),

  // FETCH BID ITEMS SITE LIST
  on(FetchBidItemsSitesListRequest, state => ({
    ...state,
    ...initialState.bidItemsSiteListInfo,
  })),
  on(FetchBidItemsSitesListSuccess, (state, props) => ({
    ...state,
    bidItemsSiteListInfo: props?.bidItemsSiteListInfo,
  })),
  on(FetchBidItemsSitesListFailure, state => ({
    ...state,
    ...initialState.bidItemsSiteListInfo,
  })),

  // FETCH CHANGE ORDER FILTERS
  on(FetchChangeOrderFilterRequest, state => ({
    ...state,
    ...initialState.changeOrderFilter,
  })),
  on(FetchChangeOrderFilterSuccess, (state, props) => ({
    ...state,
    changeOrderFilter: {
      list: props.list,
    },
  })),
  on(FetchChangeOrderFilterFailure, state => ({
    ...state,
    ...initialState.changeOrderFilter,
  })),

  // FETCH BID ITEM LIST WITH CHANGE ORDER
  on(FetchBidItemListWithChangeOrderRequest, state => ({
    ...state,
    ...initialState.bidItemsListInfo,
  })),
  on(FetchBidItemListWithChangeOrderSuccess, (state, props) => ({
    ...state,
    bidItemsListInfo: {
      list: props.bidItemsListInfo?.list,
      totalRecords: props.bidItemsListInfo?.totalRecords,
    },
  })),
  on(FetchBidItemListWithChangeOrderFailure, state => ({
    ...state,
    ...initialState.bidItemsSiteListInfo,
  })),

  // FETCH CHANGE ORDER FILTERS IN SIDE NAV
  on(FetchChangeOrderFilterInSideNavRequest, state => ({
    ...state,
    ...initialState.changeOrderFilterInSideNav,
  })),
  on(FetchChangeOrderFilterInSideNavSuccess, (state, props) => ({
    ...state,
    changeOrderFilterInSideNav: {
      list: props.list,
    },
  })),
  on(FetchChangeOrderFilterInSideNavFailure, state => ({
    ...state,
    ...initialState.changeOrderFilterInSideNav,
  })),

  // FETCH BID ITEM LIST WITH CHANGE ORDER IN SIDE NAV
  on(FetchBidItemListWithChangeOrderInSideNavRequest, state => ({
    ...state,
    ...initialState.bidItemsSiteListInfo,
  })),
  on(FetchBidItemListWithChangeOrderInSideNavSuccess, (state, props) => ({
    ...state,
    bidItemsSiteListInfo: props?.bidItemsSiteListInfo,
  })),
  on(FetchBidItemListWithChangeOrderInSideNavFailure, state => ({
    ...state,
    ...initialState.bidItemsSiteListInfo,
  })),

  // CLEAR SITES LIST
  on(ClearSitesListRequest, state => ({
    ...state,
    bidItemsSiteListInfo: initialState.bidItemsListInfo,
  })),

  // FETCH SUB CONTRACTOR FILTER
  on(FetchSubContractorFilterRequest, state => ({
    ...state,
    subContractorFilter: initialState.subContractorFilter,
  })),
  on(FetchSubContractorFilterSuccess, (state, props) => ({
    ...state,
    subContractorFilter: props.subContractorFilter,
  })),
  on(FetchSubContractorFilterFailure, state => ({
    ...state,
    subContractorFilter: initialState.subContractorFilter,
  })),

  // FETCH LABOR FILTER
  on(FetchLaborFilterRequest, state => ({
    ...state,
    laborFilter: initialState.laborFilter,
  })),
  on(FetchLaborFilterSuccess, (state, props) => ({
    ...state,
    laborFilter: props.laborFilter,
  })),
  on(FetchLaborFilterFailure, state => ({
    ...state,
    laborFilter: initialState.laborFilter,
  })),

  // FETCH EQUIPMENT FILTER
  on(FetchEquipmentFilterRequest, state => ({
    ...state,
    equipmentFilter: initialState.equipmentFilter,
  })),
  on(FetchEquipmentFilterSuccess, (state, props) => ({
    ...state,
    equipmentFilter: props.equipmentFilter,
  })),
  on(FetchEquipmentFilterFailure, state => ({
    ...state,
    equipmentFilter: initialState.equipmentFilter,
  })),

  // FETCH DAILY REPORT
  on(FetchNextActionStateRequest, state => ({
    ...state,
    dailyReportsByDate: initialState.dailyReportsByDate,
  })),
  on(FetchNextActionStateSuccess, (state, props) => ({
    ...state,
    dailyReportsByDate: props.dailyReport,
  })),
  on(FetchNextActionStateFailure, state => state),

  // FETCH EXTERNAL TESTS
  on(FetchExternalTestsRequest, state => state),
  on(FetchExternalTestsSuccess, (state, props) => ({
    ...state,
    dailyReport: props.dailyReport,
  })),
  on(FetchExternalTestsFailure, state => state),

  // FETCH ISSUE TYPES
  on(FetchIssueTypesRequest, state => ({
    ...state,
    issueTypesLabelMap: initialState.issueTypesLabelMap,
    issueTypesFilter: initialState.issueTypesFilter,
  })),
  on(FetchIssueTypesSuccess, (state, props) => ({
    ...state,
    issueTypesLabelMap: props.issueTypesLabelMap,
    issueTypesFilter: props.issueTypesFilter,
  })),
  on(FetchIssueTypesFailure, state => ({
    ...state,
    issueTypesLabelMap: initialState.issueTypesLabelMap,
    issueTypesFilter: initialState.issueTypesFilter,
  })),

  // FETCH ISSUES
  on(FetchIssuesRequest, state => ({
    ...state,
    consolidatedProjectData: {
      ...initialState.consolidatedProjectData,
    },
  })),
  on(FetchIssuesSuccess, (state, props) => ({
    ...state,
    consolidatedProjectData: {
      ...state.consolidatedProjectData,
      consolidatedIssues: props.consolidatedIssues,
    },
  })),
  on(FetchIssuesFailure, state => state),

  // FETCH ACTIVITY IDS LIST
  on(FetchActivityIdsListRequest, state => ({
    ...state,
    ...initialState.activityIdsListInfo,
  })),
  on(FetchActivityIdsListSuccess, (state, props) => ({
    ...state,
    activityIdsListInfo: {
      list: props.activityIdsListInfo.list,
      totalRecords: props.activityIdsListInfo.totalRecords,
    },
  })),
  on(FetchActivityIdsListFailure, state => ({
    ...state,
    ...state.activityIdsListInfo,
  })),

  // FETCH DAILY REPORT LINEAGE
  on(FetchDailyReportLineageRequest, state => ({
    ...state,
    dailyReportLineage: initialState.dailyReportLineage,
  })),
  on(FetchDailyReportLineageSuccess, (state, props) => ({
    ...state,
    dailyReportLineage: props.dailyReportLineage,
  })),
  on(FetchDailyReportLineageFailure, state => ({
    ...state,
    dailyReportLineage: initialState.dailyReportLineage,
  })),

  // FETCH BASIS OF PAY OPTIONS
  on(FetchBasisOfPayOptionsRequest, state => ({
    ...state,
    ...initialState.basisOfPayOptions,
  })),
  on(FetchBasisOfPayOptionsSuccess, (state, props) => ({
    ...state,
    basisOfPayOptions: props.basisOfPayOptions,
  })),
  on(FetchBasisOfPayOptionsFailure, state => ({
    ...state,
    ...initialState.basisOfPayOptions,
  })),

  // FETCH BASIS OF PAY OPTIONS
  on(FetchBasisOfPayOptionsRequest, state => ({
    ...state,
    ...initialState.basisOfPayOptions,
  })),
  on(FetchBasisOfPayOptionsSuccess, (state, props) => ({
    ...state,
    basisOfPayOptions: props.basisOfPayOptions,
  })),
  on(FetchBasisOfPayOptionsFailure, state => ({
    ...state,
    ...initialState.basisOfPayOptions,
  })),

  // FETCH CHANGE IN WORK CODE OPTIONS
  on(FetchChangeInWorkCodeOptionsRequest, state => ({
    ...state,
    ...initialState.changeInWorkCodeOptions,
  })),
  on(FetchChangeInWorkCodeOptionsSuccess, (state, props) => ({
    ...state,
    changeInWorkCodeOptions: props.changeInWorkCodeOptions,
  })),
  on(FetchChangeInWorkCodeOptionsFailure, state => ({
    ...state,
    ...initialState.changeInWorkCodeOptions,
  })),

  // FETCH CHANGE IN WORK REQUEST LIST
  on(FetchChangeInWorkRequestListRequest, state => ({
    ...state,
    ...initialState.changeInWorkRequestListInfo,
  })),
  on(FetchChangeInWorkRequestListSuccess, (state, props) => ({
    ...state,
    changeInWorkRequestListInfo: {
      ...props.changeInWorkRequestListInfo,
    },
  })),
  on(FetchChangeInWorkRequestListFailure, state => ({
    ...state,
    ...state.changeInWorkRequestListInfo,
  })),

  // FETCH CHANGE ORDERS REQUEST LIST
  on(FetchChangeOrdersRequestListRequest, state => ({
    ...state,
    ...initialState.changeOrdersRequestListInfo,
  })),
  on(FetchChangeOrdersRequestListSuccess, (state, props) => ({
    ...state,
    changeOrdersRequestListInfo: {
      ...props.changeOrdersRequestListInfo,
    },
  })),
  on(FetchChangeOrdersRequestListFailure, state => ({
    ...state,
    ...state.changeOrdersRequestListInfo,
  })),

  // FETCH CHANGE IN WORK REQUEST WITH ID
  on(FetchChangeInWorkRequestWithIdRequest, (state, action) => ({
    ...state,
    changeInWorkRequest: (state.changeInWorkRequest as any)?.id === action.payload?.changeInWorkRequestId
      ? state.changeInWorkRequest
      : initialState.changeInWorkRequest,
  })),
  on(FetchChangeInWorkRequestWithIdSuccess, (state, props) => ({
    ...state,
    changeInWorkRequest: props.changeInWorkRequest,
  })),
  on(FetchChangeInWorkRequestWithIdFailure, state => ({
    ...state,
    changeInWorkRequest: initialState.changeInWorkRequest,
  })),

  // FETCH CHANGE ORDERS REQUEST WITH ID
  on(FetchChangeOrdersRequestWithIdRequest, (state, action) => ({
    ...state,
    changeOrdersRequest: (state.changeOrdersRequest as any)?.id === action.payload?.changeOrdersRequestId
      ? state.changeOrdersRequest
      : initialState.changeOrdersRequest,
  })),
  on(FetchChangeOrdersRequestWithIdSuccess, (state, props) => ({
    ...state,
    changeOrdersRequest: props.changeOrdersRequest,
  })),
  on(FetchChangeOrdersRequestWithIdFailure, state => ({
    ...state,
    changeOrdersRequest: initialState.changeOrdersRequest,
  })),

  // UPDATE CHANGE ORDERS REQUEST AFTER SAVE/SUBMIT
  on(SaveChangeOrdersRequestSuccess, (state, props) => ({
    ...state,
    changeOrdersRequest: props.data || state.changeOrdersRequest,
  })),

  // FETCH AVAILABLE CORS
  on(FetchAvailableCorsRequest, state => ({
    ...state,
    availableCors: { list: [] },
  })),
  on(FetchAvailableCorsSuccess, (state, props) => ({
    ...state,
    availableCors: { list: props.data },
  })),
  on(FetchAvailableCorsFailure, state => ({
    ...state,
    availableCors: { list: [] },
  })),

  // SCAN BATCH TICKET
  on(ScanBatchTicketRequest, state => ({
    ...state,
    batchTicketData: null,
    batchTicketLoading: true,
  })),
  on(ScanBatchTicketSuccess, (state, props) => ({
    ...state,
    batchTicketData: props.data,
    batchTicketLoading: false,
  })),
  on(ScanBatchTicketFailure, state => ({
    ...state,
    batchTicketData: null,
    batchTicketLoading: false,
  })),
  on(ClearBatchTicketData, state => ({
    ...state,
    batchTicketData: null,
    batchTicketLoading: false,
  })),

  // FETCH REPORT
  on(FetchReportRequest, state => ({
    ...state,
    ...initialState.reportInfo,
  })),
  on(FetchReportSuccess, (state, props) => ({
    ...state,
    reportInfo: props.reportInfo,
  })),
  on(FetchReportFailure, state => ({
    ...state,
    ...initialState.reportInfo,
  })),

  /******** FETCH LINEAGE ***********/
  on(FetchLineageRequest, state => ({
    ...state,
    ...initialState.lineageList,
  })),
  on(FetchLineageSuccess, (state, props) => ({
    ...state,
    lineageList: props.lineageList,
  })),
  on(FetchLineageFailure, state => ({
    ...state,
    ...initialState.lineageList,
  })),

  // CLEAR CHANGE ORDER REQUEST WITH ID
  on(ClearChangeOrdersRequestWithId, state => ({
    ...state,
    changeOrdersRequest: initialState.changeOrdersRequest,
  })),

  // CLEAR CHANGE IN WORK REQUEST WITH ID
  on(ClearChangeInWorkRequestWithId, state => ({
    ...state,
    changeInWorkRequest: initialState.changeInWorkRequest,
  })),

  // CLEAR SUBMITTALS ITEM DETAILS WITH ID
  on(ClearSubmittalsItemDetailsWithId, state => ({
    ...state,
    submittalsItemDetails: initialState.submittalsItemDetails,
  })),

  // CLEAR RFI ITEM DETAILS WITH ID
  on(ClearRFIItemDetailsWithId, state => ({
    ...state,
    rfiItemDetails: initialState.rfiItemDetails,
  })),

  // FETCH SUBMITTALS REGISTRY LIST
  on(FetchSubmittalsRegistryListRequest, state => ({
    ...state,
    ...initialState.submittalsRegistryListInfo,
  })),
  on(FetchSubmittalsRegistryListSuccess, (state, props) => ({
    ...state,
    submittalsRegistryListInfo: {
      list: props.submittalsRegistryListInfo.list,
      totalRecords: props.submittalsRegistryListInfo.totalRecords,
    },
  })),
  on(FetchSubmittalsRegistryListFailure, state => ({
    ...state,
    ...state.submittalsRegistryListInfo,
  })),

  // FETCH SUBMITTALS ITEMS LIST
  on(FetchSubmittalsItemsListRequest, state => ({
    ...state,
    ...initialState.submittalsItemsListInfo,
  })),
  on(FetchSubmittalsItemsListSuccess, (state, props) => ({
    ...state,
    submittalsItemsListInfo: {
      list: props.submittalsItemsListInfo.list,
      totalRecords: props.submittalsItemsListInfo.totalRecords,
    },
  })),
  on(FetchSubmittalsItemsListFailure, state => ({
    ...state,
    ...state.submittalsItemsListInfo,
  })),

  // FETCH USERS LIST
  on(FetchUsersListRequest, state => ({
    ...state,
    ...initialState.usersListInfo,
  })),
  on(FetchUsersListSuccess, (state, props) => ({
    ...state,
    usersListInfo: {
      list: props.usersListInfo.list,
    },
  })),
  on(FetchUsersListFailure, state => ({
    ...state,
    ...state.usersListInfo,
  })),

  // FETCH PROJECT ROLES LIST
  on(FetchProjectRolesListRequest, state => ({
    ...state,
    projectRolesListInfo: {
      ...initialState.projectRolesListInfo,
    },
  })),
  on(FetchProjectRolesListSuccess, (state, props) => ({
    ...state,
    projectRolesListInfo: {
      list: props.projectRolesListInfo.list,
    },
  })),
  on(FetchProjectRolesListFailure, state => ({
    ...state,
    ...state.projectRolesListInfo,
  })),

  // FETCH SUBMITTALS ITEM DETAILS WITH ID
  on(FetchSubmittalsItemDetailsWithIdRequest, state => ({
    ...state,
    ...initialState.submittalsItemDetails,
  })),
  on(FetchSubmittalsItemDetailsWithIdSuccess, (state, props) => ({
    ...state,
    submittalsItemDetails: {
      ...props.submittalsItemDetails,
    },
  })),
  on(FetchSubmittalsItemDetailsWithIdFailure, state => ({
    ...state,
    ...state.submittalsItemDetails,
  })),

  // DELETE SUBMITTALS ITEM
  on(DeleteSubmittalsItemSuccess, state => ({
    ...state,
    submittalsItemDetails: {},
  })),

  // FETCH RFI ITEM DETAILS WITH ID
  on(FetchRFIItemDetailsWithIdRequest, state => ({
    ...state,
    ...initialState.rfiItemDetails,
  })),
  on(FetchRFIItemDetailsWithIdSuccess, (state, props) => ({
    ...state,
    rfiItemDetails: {
      ...props.rfiItemDetails,
    },
  })),
  on(FetchRFIItemDetailsWithIdFailure, state => ({
    ...state,
    ...state.rfiItemDetails,
  })),

  // FETCH RFIS LIST
  on(FetchRFIsListRequest, state => ({
    ...state,
    ...initialState.rfisListInfo,
  })),
  on(FetchRFIsListSuccess, (state, props) => ({
    ...state,
    rfisListInfo: {
      list: props.rfisListInfo.list,
      totalRecords: props.rfisListInfo.totalRecords,
    },
  })),
  on(FetchRFIsListFailure, state => ({
    ...state,
    ...state.rfisListInfo,
  })),

  // FETCH PROJECT MEMBERS LIST
  on(FetchProjectMembersListRequest, state => ({
    ...state,
    projectMembersListInfo: {
      ...initialState.projectMembersListInfo,
    },
  })),
  on(FetchProjectMembersListSuccess, (state, props) => ({
    ...state,
    projectMembersListInfo: {
      list: props.projectMembersListInfo.list,
      totalRecords: props.projectMembersListInfo.totalRecords,
    },
  })),
  on(FetchProjectMembersListFailure, state => ({
    ...state,
    ...state.projectMembersListInfo,
  })),

  // FETCH CONTRACTORS LIST
  on(FetchContractorsListRequest, state => ({
    ...state,
    contractorsListInfo: {
      ...initialState.contractorsListInfo,
    },
  })),
  on(FetchContractorsListSuccess, (state, props) => ({
    ...state,
    contractorsListInfo: {
      list: props.contractorsListInfo.list,
      totalRecords: props.contractorsListInfo.totalRecords,
    },
  })),
  on(FetchContractorsListFailure, state => ({
    ...state,
    ...state.contractorsListInfo,
  })),

  // FETCH DELIVERY TRACKING FIELDS
  on(FetchDeliveryTrackingFieldsRequest, state => ({
    ...state,
    deliveryTrackingFieldsListInfo: {
      ...initialState.deliveryTrackingFieldsListInfo,
    },
  })),
  on(FetchDeliveryTrackingFieldsSuccess, (state, props) => ({
    ...state,
    deliveryTrackingFieldsListInfo: {
      list: props.deliveryTrackingFieldsListInfo.list,
      totalRecords: props.deliveryTrackingFieldsListInfo.totalRecords,
    },
  })),
  on(FetchDeliveryTrackingFieldsFailure, state => ({
    ...state,
    deliveryTrackingFieldsListInfo: {
      ...initialState.deliveryTrackingFieldsListInfo,
    },
  })),

  // FETCH SITES LIST
  on(FetchSitesListRequest, state => ({
    ...state,
    sitesListInfo: {
      ...initialState.sitesListInfo,
    },
  })),
  on(FetchSitesListSuccess, (state, props) => ({
    ...state,
    sitesListInfo: {
      list: props.sitesListInfo.list,
      totalRecords: props.sitesListInfo.totalRecords,
    },
  })),
  on(FetchSitesListFailure, state => ({
    ...state,
    ...state.sitesListInfo,
  })),

  // FETCH EXISTING MEMBERS LIST
  on(FetchExistingMembersListRequest, state => ({
    ...state,
    existingMembersListInfo: {
      ...initialState.existingMembersListInfo,
    },
  })),
  on(FetchExistingMembersListSuccess, (state, props) => ({
    ...state,
    existingMembersListInfo: {
      list: props.existingMembersListInfo.list,
    },
  })),
  on(FetchExistingMembersListFailure, state => ({
    ...state,
    ...state.existingMembersListInfo,
  })),

  // FETCH LABOR LOOKUP
  on(FetchLaborLookupRequest, state => ({
    ...state,
    laborLookupData: {
      ...initialState.laborLookupData,
    },
  })),
  on(FetchLaborLookupSuccess, (state, props) => ({
    ...state,
    laborLookupData: {
      list: props.laborLookupData?.list || [],
      totalRecords: props.laborLookupData?.totalRecords || 0,
    },
  })),
  on(FetchLaborLookupFailure, state => ({
    ...state,
    ...state.laborLookupData,
  })),

  // CREATE LABOR LOOKUP
  on(CreateLaborLookupRequest, state => ({
    ...state,
  })),
  on(CreateLaborLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(CreateLaborLookupFailure, state => ({
    ...state,
  })),

  // FETCH EQUIPMENT LOOKUP
  on(FetchEquipmentLookupRequest, state => ({
    ...state,
    equipmentLookupData: {
      ...initialState.equipmentLookupData,
    },
  })),
  on(FetchEquipmentLookupSuccess, (state, props) => ({
    ...state,
    equipmentLookupData: {
      list: props.equipmentLookupData?.list || [],
      totalRecords: props.equipmentLookupData?.totalRecords || 0,
    },
  })),
  on(FetchEquipmentLookupFailure, state => ({
    ...state,
    ...state.equipmentLookupData,
  })),

  // CREATE EQUIPMENT LOOKUP
  on(CreateEquipmentLookupRequest, state => ({
    ...state,
  })),
  on(CreateEquipmentLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(CreateEquipmentLookupFailure, state => ({
    ...state,
  })),

  // FETCH ACTIVITY TYPE LOOKUP
  on(FetchActivityTypeLookupRequest, state => ({
    ...state,
    activityTypeLookupData: {
      ...initialState.activityTypeLookupData,
    },
  })),
  on(FetchActivityTypeLookupSuccess, (state, props) => ({
    ...state,
    activityTypeLookupData: {
      list: props.activityTypeLookupData?.list || [],
      totalRecords: props.activityTypeLookupData?.totalRecords || 0,
    },
  })),
  on(FetchActivityTypeLookupFailure, state => ({
    ...state,
    ...state.activityTypeLookupData,
  })),

  // CREATE ACTIVITY TYPE LOOKUP
  on(CreateActivityTypeLookupRequest, state => ({
    ...state,
  })),
  on(CreateActivityTypeLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(CreateActivityTypeLookupFailure, state => ({
    ...state,
  })),

  // DELETE LABOR LOOKUP
  on(DeleteLaborLookupRequest, state => ({
    ...state,
  })),
  on(DeleteLaborLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(DeleteLaborLookupFailure, state => ({
    ...state,
  })),

  // DELETE EQUIPMENT LOOKUP
  on(DeleteEquipmentLookupRequest, state => ({
    ...state,
  })),
  on(DeleteEquipmentLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(DeleteEquipmentLookupFailure, state => ({
    ...state,
  })),

  // DELETE ACTIVITY TYPE LOOKUP
  on(DeleteActivityTypeLookupRequest, state => ({
    ...state,
  })),
  on(DeleteActivityTypeLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(DeleteActivityTypeLookupFailure, state => ({
    ...state,
  })),

  // FETCH EXTERNAL LAB LOOKUP
  on(FetchExternalLabLookupRequest, state => ({
    ...state,
    externalLabLookupData: {
      ...initialState.externalLabLookupData,
    },
  })),
  on(FetchExternalLabLookupSuccess, (state, props) => ({
    ...state,
    externalLabLookupData: {
      list: props.externalLabLookupData?.list || [],
      totalRecords: props.externalLabLookupData?.totalRecords || 0,
    },
  })),
  on(FetchExternalLabLookupFailure, state => ({
    ...state,
  })),

  // CREATE EXTERNAL LAB
  on(CreateExternalLabRequest, state => ({
    ...state,
  })),
  on(CreateExternalLabSuccess, (state, props) => ({
    ...state,
  })),
  on(CreateExternalLabFailure, state => ({
    ...state,
  })),

  // UPDATE EXTERNAL LAB
  on(UpdateExternalLabRequest, state => ({
    ...state,
  })),
  on(UpdateExternalLabSuccess, (state, props) => ({
    ...state,
  })),
  on(UpdateExternalLabFailure, state => ({
    ...state,
  })),

  // DELETE EXTERNAL LAB LOOKUP
  on(DeleteExternalLabLookupRequest, state => ({
    ...state,
  })),
  on(DeleteExternalLabLookupSuccess, (state, props) => ({
    ...state,
  })),
  on(DeleteExternalLabLookupFailure, state => ({
    ...state,
  })),

  // FETCH MATERIAL TEST LAB LIST (EXTERNAL LABS)
  on(FetchMaterialTestLabListRequest, state => ({
    ...state,
    externalLabListInfo: {
      ...initialState.externalLabListInfo,
    },
  })),
  on(FetchMaterialTestLabListSuccess, (state, props) => ({
    ...state,
    externalLabListInfo: {
      list: props.externalLabListInfo?.list || [],
      totalRecords: props.externalLabListInfo?.totalRecords || 0,
    },
  })),
  on(FetchMaterialTestLabListFailure, state => ({
    ...state,
  })),

  // FETCH RFI NO
  on(FetchRFINoRequest, state => ({
    ...state,
    ...initialState.rfiNo,
  })),
  on(FetchRFINoSuccess, (state, props) => ({
    ...state,
    rfiNo: props.rfiNo,
  })),
  on(FetchRFINoFailure, state => ({
    ...state,
    ...state.rfiNo,
  })),

  // FETCH MATERIAL TEST NAME LIST
  on(FetchMaterialTestNameListRequest, state => ({
    ...state,
    ...initialState.materialTestNameList,
  })),
  on(FetchMaterialTestNameListSuccess, (state, props) => ({
    ...state,
    materialTestNameList: props.list,
  })),
  on(FetchMaterialTestNameListFailure, state => ({
    ...state,
    ...state.materialTestNameList,
  })),

  // FETCH PROJECT MATERIAL TEST LIST
  on(FetchProjectMaterialTestListRequest, state => ({
    ...state,
    projectMaterialTestListInfo: {
      ...initialState.projectMaterialTestListInfo,
    },
  })),
  on(FetchProjectMaterialTestListSuccess, (state, props) => ({
    ...state,
    projectMaterialTestListInfo: {
      list: props.projectMaterialTestListInfo?.list || [],
      totalRecords: props.projectMaterialTestListInfo?.totalRecords || 0,
    },
  })),
  on(FetchProjectMaterialTestListFailure, state => ({
    ...state,
  })),

  // FETCH LAB NAME LIST
  on(FetchLabNameListRequest, state => ({
    ...state,
    ...initialState.labNameList,
  })),
  on(FetchLabNameListSuccess, (state, props) => ({
    ...state,
    labNameList: props.list,
  })),
  on(FetchLabNameListFailure, state => ({
    ...state,
    ...state.labNameList,
  })),

  // CREATE DAILY REPORT DRAFT
  on(CreateDailyReportDraftRequest, state => ({
    ...state,
    ...initialState.draftDailyReport,
  })),
  on(CreateDailyReportDraftSuccess, (state, props) => ({
    ...state,
    draftDailyReport: props.data,
  })),
  on(CreateDailyReportDraftFailure, state => ({
    ...state,
    ...state.draftDailyReport,
  })),

  // FETCH BILLING SETTINGS
  on(FetchBillingSettingsRequest, (state) => ({
    ...state,
    billingSettings: initialState.billingSettings,
  })),
  on(FetchBillingSettingsSuccess, (state, props) => ({
    ...state,
    billingSettings: props.billingSettings,
  })),
  on(FetchBillingSettingsFailure, (state) => ({
    ...state,
    billingSettings: initialState.billingSettings,
  })),

  // UPDATE BILLING SETTINGS
  on(UpdateBillingSettingsRequest, (state) => state),
  on(UpdateBillingSettingsSuccess, (state, props) => ({
    ...state,
    billingSettings: props.billingSettings,
  })),
  on(UpdateBillingSettingsFailure, (state) => state),

  // FETCH PAY APP SUMMARY
  on(FetchPayAppSummaryRequest, (state) => state),
  on(FetchPayAppSummarySuccess, (state, props) => ({
    ...state,
    payAppSummaries: {
      ...state.payAppSummaries,
      [props.payAppId]: props.summary,
    },
  })),
  on(FetchPayAppSummaryFailure, (state) => state),

  // CLEAR BILLING SETTINGS
  on(ClearBillingSettings, (state) => ({
    ...state,
    billingSettings: initialState.billingSettings,
  })),

  // FETCH PROJECT CALENDAR
  on(FetchProjectCalendarRequest, (state) => ({
    ...state,
    projectCalendarLoading: true,
  })),
  on(FetchProjectCalendarSuccess, (state, props) => ({
    ...state,
    projectCalendar: props.calendar,
    projectCalendarLoading: false,
  })),
  on(FetchProjectCalendarFailure, (state) => ({
    ...state,
    projectCalendar: null,
    projectCalendarLoading: false,
  })),

  // UPDATE PROJECT CALENDAR
  on(UpdateProjectCalendarRequest, (state) => ({
    ...state,
    projectCalendarLoading: true,
  })),
  on(UpdateProjectCalendarSuccess, (state, props) => ({
    ...state,
    projectCalendar: props.calendar,
    projectCalendarLoading: false,
  })),
  on(UpdateProjectCalendarFailure, (state) => ({
    ...state,
    projectCalendarLoading: false,
  })),

  // INITIALIZE PROJECT CALENDAR
  on(InitializeProjectCalendarRequest, (state) => ({
    ...state,
    projectCalendarLoading: true,
  })),
  on(InitializeProjectCalendarSuccess, (state, props) => ({
    ...state,
    projectCalendar: props.calendar,
    projectCalendarLoading: false,
  })),
  on(InitializeProjectCalendarFailure, (state) => ({
    ...state,
    projectCalendarLoading: false,
  })),

  // FETCH PAY APP TEMPLATES
  on(FetchPayAppTemplatesRequest, (state) => ({
    ...state,
    payAppTemplatesLoading: true,
  })),
  on(FetchPayAppTemplatesSuccess, (state, props) => ({
    ...state,
    payAppTemplates: props.templates,
    payAppTemplatesLoading: false,
  })),
  on(FetchPayAppTemplatesFailure, (state) => ({
    ...state,
    payAppTemplates: [],
    payAppTemplatesLoading: false,
  })),

  // CREATE PAY APP TEMPLATE
  on(CreatePayAppTemplateRequest, (state) => state),
  on(CreatePayAppTemplateSuccess, (state, props) => ({
    ...state,
    payAppTemplates: [...state.payAppTemplates, props.template],
  })),
  on(CreatePayAppTemplateFailure, (state) => state),

  // UPDATE PAY APP TEMPLATE
  on(UpdatePayAppTemplateRequest, (state) => state),
  on(UpdatePayAppTemplateSuccess, (state, props) => ({
    ...state,
    payAppTemplates: state.payAppTemplates.map(t =>
      t.id === props.template.id ? props.template : t
    ),
  })),
  on(UpdatePayAppTemplateFailure, (state) => state),

  // DELETE PAY APP TEMPLATE
  on(DeletePayAppTemplateRequest, (state) => state),
  on(DeletePayAppTemplateSuccess, (state, props) => ({
    ...state,
    payAppTemplates: state.payAppTemplates.filter(t => t.id !== props.templateId),
  })),
  on(DeletePayAppTemplateFailure, (state) => state),

  // PREVIEW PAY APP TEMPLATE
  on(PreviewPayAppTemplateRequest, (state) => ({
    ...state,
    templatePreviewUrl: null,
  })),
  on(PreviewPayAppTemplateSuccess, (state, props) => ({
    ...state,
    templatePreviewUrl: props.previewUrl,
  })),
  on(PreviewPayAppTemplateFailure, (state) => ({
    ...state,
    templatePreviewUrl: null,
  })),

  // CLEAR PAY APP TEMPLATES
  on(ClearPayAppTemplates, (state) => ({
    ...state,
    payAppTemplates: initialState.payAppTemplates,
    payAppTemplatesLoading: false,
    selectedPayAppTemplate: null,
    templatePreviewUrl: null,
  })),

  // CHECK EMAIL EXISTS
  on(CheckEmailExistsRequest, state => ({
    ...state,
    emailExistsCheck: null,
  })),
  on(CheckEmailExistsSuccess, (state, props) => ({
    ...state,
    emailExistsCheck: {
      email: props?.email,
      exists: props?.exists || false,
      account: props?.account || null,
    },
  })),
  on(CheckEmailExistsFailure, (state, props) => ({
    ...state,
    emailExistsCheck: null,
  })),

  // CHECK PHONE EXISTS
  on(CheckPhoneExistsRequest, state => ({
    ...state,
    phoneExistsCheck: null,
  })),
  on(CheckPhoneExistsSuccess, (state, props) => ({
    ...state,
    phoneExistsCheck: {
      phone: props?.phone,
      exists: props?.exists || false,
      account: props?.account || null,
    },
  })),
  on(CheckPhoneExistsFailure, (state, props) => ({
    ...state,
    phoneExistsCheck: null,
  })),

  // CLEAR EMAIL EXISTS CHECK
  on(ClearEmailExistsCheck, state => ({
    ...state,
    emailExistsCheck: null,
  })),

  // CLEAR PHONE EXISTS CHECK
  on(ClearPhoneExistsCheck, state => ({
    ...state,
    phoneExistsCheck: null,
  })),

  // WARRANTY
  on(FetchWarrantiesSuccess, (state, props) => ({
    ...state,
    warrantiesInfo: props.warrantiesInfo,
  })),
  on(FetchWarrantyClaimsSuccess, (state, props) => ({
    ...state,
    warrantyClaimsInfo: props.warrantyClaimsInfo,
  })),
  on(FetchWarrantyClaimDetailSuccess, (state, props) => ({
    ...state,
    warrantyClaimDetail: props.warrantyClaimDetail,
  })),
);
